/* FlipBuy collection page enhancements, v-1.6. Survives the AJAX filter re-render by re-applying on DOM changes. */
(function () {
  var COLOURS = {
    black: '#111111', white: '#ffffff', grey: '#9ca3af', silver: '#c7cbd1', gold: '#c9a227',
    beige: '#d9c7a7', brown: '#7b5233', navy: '#1f2a52', blue: '#2f6fd6', green: '#3d8b4f',
    red: '#c62828', pink: '#ef8fb1', purple: '#7e57c2', yellow: '#f2c94c', orange: '#f2994a',
    multicolour: 'conic-gradient(#ef4444,#f59e0b,#10b981,#3b82f6,#8b5cf6,#ef4444)',
    clear: 'repeating-linear-gradient(45deg,#ffffff 0 3px,#e5e7eb 3px 6px)'
  };
  var KEY = 'fbFacetState';
  var LIMIT = 8;

  function getState() { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function setState(s) { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  function updateBadge(f) {
    var titleEl = f.querySelector('.widget-title');
    if (!titleEl) return;
    var n = f.querySelectorAll('input[type="checkbox"]:checked').length;
    var badge = titleEl.querySelector('.fb-facet-count');
    if (!n) { if (badge) badge.remove(); return; }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'fb-facet-count';
      titleEl.appendChild(badge);
    }
    if (badge.textContent !== String(n)) {
      badge.textContent = n;
      badge.setAttribute('aria-label', n + ' selected');
    }
  }

  function enhanceFilters() {
    var filters = document.querySelectorAll('#FacetsWrapperDesktop .js-filter');
    Array.prototype.forEach.call(filters, function (f) {
      updateBadge(f);
      // The filter form re-render replaces the inner HTML of each .js-filter, so mark the content, not the wrapper.
      if (f.querySelector('.fb-mark')) return;
      var mark = document.createElement('span');
      mark.className = 'fb-mark';
      mark.hidden = true;
      f.appendChild(mark);
      var titleEl = f.querySelector('.widget-title');
      var label = titleEl ? (titleEl.firstChild && titleEl.firstChild.nodeType === 3 ? titleEl.firstChild.textContent : titleEl.textContent).replace(/\d+$/, '').trim() : '';
      var state = getState();
      var summary = f.querySelector('.facets__summary');
      var body = f.querySelector('.facets-filter');
      var checked = f.querySelectorAll('input[type="checkbox"]:checked').length;
      var priceSet = Array.prototype.some.call(f.querySelectorAll('.facets__price input'), function (i) { return i.value; });

      if (state[label] === true && !checked && !priceSet) f.classList.add('fb-collapsed');

      if (summary) {
        summary.setAttribute('role', 'button');
        summary.setAttribute('tabindex', '0');
        summary.setAttribute('aria-expanded', f.classList.contains('fb-collapsed') ? 'false' : 'true');
        var toggle = function () {
          var collapsed = f.classList.toggle('fb-collapsed');
          summary.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          var s = getState(); s[label] = collapsed; setState(s);
        };
        summary.addEventListener('click', toggle);
        summary.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      }

      var items = f.querySelectorAll('.facets__item');
      if (items.length > LIMIT + 2 && body) {
        var anyHiddenChecked = false;
        Array.prototype.forEach.call(items, function (li, i) {
          if (i >= LIMIT) {
            li.classList.add('fb-extra');
            if (li.querySelector('input:checked')) anyHiddenChecked = true;
          }
        });
        f.classList.remove('fb-clamped');
        if (!state[label + ':more'] && !anyHiddenChecked) f.classList.add('fb-clamped');
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'fb-more';
        var update = function () {
          more.textContent = f.classList.contains('fb-clamped') ? 'Show all ' + items.length : 'Show fewer';
          more.setAttribute('aria-expanded', f.classList.contains('fb-clamped') ? 'false' : 'true');
        };
        update();
        more.addEventListener('click', function () {
          f.classList.toggle('fb-clamped');
          update();
          var s = getState(); s[label + ':more'] = !f.classList.contains('fb-clamped'); setState(s);
        });
        body.appendChild(more);
      }

      if (/colou?r/i.test(label)) {
        f.classList.add('fb-colour');
        Array.prototype.forEach.call(f.querySelectorAll('.facets__item label'), function (l) {
          var input = l.querySelector('input');
          if (!input || l.querySelector('.fb-sw')) return;
          var c = COLOURS[(input.value || '').toLowerCase().trim()];
          if (!c) return;
          var sw = document.createElement('span');
          sw.className = 'fb-sw';
          sw.setAttribute('aria-hidden', 'true');
          sw.style.background = c;
          input.insertAdjacentElement('afterend', sw);
        });
      }
    });
  }

  function toggleClearAll() {
    var any = document.querySelector('#FacetsWrapperDesktop input[type="checkbox"]:checked') ||
      Array.prototype.some.call(document.querySelectorAll('#FacetsWrapperDesktop .facets__price input'), function (i) { return i.value; });
    Array.prototype.forEach.call(document.querySelectorAll('.active-facets-desktop'), function (el) {
      el.style.display = any ? '' : 'none';
    });
  }

  function enhanceChips() {
    var box = document.querySelector('[data-fb-chips]');
    if (!box || box.getAttribute('data-fb') === '1') return;
    box.setAttribute('data-fb', '1');
    var inputs = document.querySelectorAll('#FacetsWrapperDesktop input[type="checkbox"]:checked');
    Array.prototype.forEach.call(inputs, function (input) {
      var l = input.closest('label');
      var text = (l ? l.textContent : input.value).replace(/\(\d+\)\s*$/, '').trim();
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'fb-chip';
      chip.setAttribute('aria-label', 'Remove filter: ' + text);
      var span = document.createElement('span');
      span.textContent = text;
      chip.appendChild(span);
      chip.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>');
      chip.addEventListener('click', function () { input.click(); });
      box.appendChild(chip);
    });
    if (inputs.length) {
      var clear = document.createElement('a');
      clear.className = 'fb-chip fb-chip--clear';
      clear.href = window.location.pathname;
      clear.textContent = 'Clear all';
      box.appendChild(clear);
    }
  }

  function textOf(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function linkLines(p) {
    if (p.tagName !== 'P') return null;
    var lines = p.innerHTML.split(/<br\s*\/?>/i).map(function (l) { return l.trim(); }).filter(Boolean);
    if (!lines.length) return null;
    for (var i = 0; i < lines.length; i++) if (!/^<a\s[^>]*>/i.test(lines[i])) return null;
    return lines;
  }

  // Turns a section that is only lists of links (e.g. "Browse by category") into a card grid above the guide.
  function buildDirectory(g, s) {
    var sec = document.createElement('section');
    sec.className = 'fb-dir';
    sec.innerHTML = '<p class="fb-eyebrow">Explore</p><h2 class="fb-section-title"></h2><div class="fb-dir__grid"></div>';
    sec.querySelector('h2').textContent = textOf(s.h);
    var grid = sec.querySelector('.fb-dir__grid');
    var list = null;
    s.els.forEach(function (e) {
      if (e.tagName === 'H4' || !list) {
        var card = document.createElement('div');
        card.className = 'fb-dir__card';
        var h = document.createElement('h3');
        h.textContent = e.tagName === 'H4' ? textOf(e) : textOf(s.h);
        list = document.createElement('ul');
        list.className = 'fb-dir__list';
        card.appendChild(h);
        card.appendChild(list);
        grid.appendChild(card);
        if (e.tagName === 'H4') return;
      }
      (linkLines(e) || []).forEach(function (line) {
        var m = line.match(/^(<a\s[^>]*>[\s\S]*?<\/a>)([\s\S]*)$/i);
        if (!m) return;
        var li = document.createElement('li');
        var rest = m[2].replace(/^\s*[:–-]\s*/, '').replace(/^\s*\.\s*$/, '').trim();
        if (/^(and|or|&amp;|,)\s/i.test(rest)) {
          var sp0 = document.createElement('span');
          sp0.innerHTML = line;
          li.appendChild(sp0);
        } else {
          li.innerHTML = m[1];
          if (rest) {
            var sp = document.createElement('span');
            sp.innerHTML = rest.charAt(0).toUpperCase() + rest.slice(1);
            li.appendChild(sp);
          }
        }
        list.appendChild(li);
      });
    });
    g.parentNode.insertBefore(sec, g);
  }

  function enhanceGuide() {
    var guides = document.querySelectorAll('[data-fb-guide]');
    Array.prototype.forEach.call(guides, function (g) {
      if (g.getAttribute('data-fb') === '1') return;
      g.setAttribute('data-fb', '1');
      var btn = g.querySelector('.fb-guide__toggle');
      var body = g.querySelector('.fb-guide__body');
      var layout = g.querySelector('.fb-guide__layout');
      if (!btn || !body) return;

      // Split the guide into sections at each H3 (the description's H2s).
      var secs = [], cur = null;
      Array.prototype.slice.call(body.children).forEach(function (k) {
        if (k.tagName === 'H3' || !cur) {
          cur = { h: k.tagName === 'H3' ? k : null, els: [] };
          secs.push(cur);
          if (k.tagName === 'H3') return;
        }
        cur.els.push(k);
      });

      secs.forEach(function (s) {
        var ps = s.els.filter(function (e) { return e.tagName === 'P'; });
        var onlyLinks = s.h && ps.length && ps.every(function (p) { return linkLines(p); }) &&
          s.els.every(function (e) { return e.tagName === 'P' || e.tagName === 'H4'; });
        if (!onlyLinks) return;
        buildDirectory(g, s);
        s.removed = true;
        s.h.remove();
        s.els.forEach(function (e) { e.remove(); });
      });

      var rest = secs.filter(function (s) { return !s.removed && (s.h || s.els.length); });
      if (!rest.length) { g.hidden = true; return; }
      rest.forEach(function (s, i) {
        var w = document.createElement('div');
        w.className = 'fb-g-sec';
        w.id = 'fb-g-' + (i + 1);
        body.insertBefore(w, s.h || s.els[0]);
        if (s.h) w.appendChild(s.h);
        s.els.forEach(function (e) { w.appendChild(e); });
      });

      var open = function () {
        g.classList.add('fb-open');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = 'Show less';
      };

      var titled = rest.filter(function (s) { return s.h; });
      if (titled.length >= 3 && layout) {
        var nav = document.createElement('nav');
        nav.className = 'fb-guide__toc';
        nav.setAttribute('aria-label', 'In this guide');
        nav.innerHTML = '<p class="fb-guide__toc-title">In this guide</p><ol></ol>';
        var ol = nav.querySelector('ol');
        rest.forEach(function (s, i) {
          if (!s.h) return;
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#fb-g-' + (i + 1);
          a.textContent = textOf(s.h);
          a.addEventListener('click', open);
          li.appendChild(a);
          ol.appendChild(li);
        });
        layout.insertBefore(nav, layout.firstChild);
        g.classList.add('fb-guide--toc');
      }

      if ((layout || body).scrollHeight <= 600) { g.classList.add('fb-open'); btn.hidden = true; return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (!g.classList.contains('fb-open')) { open(); return; }
        g.classList.remove('fb-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Read the full guide';
        g.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function enhanceIntro() {
    var intro = document.querySelector('.fb-coll-intro');
    if (!intro || intro.getAttribute('data-fb') === '1') return;
    intro.setAttribute('data-fb', '1');
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    intro.classList.add('fb-clamp');
    if (intro.scrollHeight <= intro.clientHeight + 2) { intro.classList.remove('fb-clamp'); return; }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fb-intro-more';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = intro.classList.toggle('fb-clamp') === false;
      btn.textContent = open ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    intro.insertAdjacentElement('afterend', btn);
  }

  function run() { enhanceFilters(); toggleClearAll(); enhanceChips(); enhanceIntro(); enhanceGuide(); }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; run(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
